import { Grid, SxProps } from '@mui/material';
import { combineSX } from '@/utils/combineSX';
import { DpBottomContainer } from '@/components/blocks/DpBottomContainer';
import React from 'react';

interface DpSEOSectionProps {
	children: React.ReactNode;
	sx?: SxProps;
	sxgrid?: SxProps;
}

export const DpSEOFrame: React.FC<DpSEOSectionProps> = ({ children, sx, sxgrid, ...props }) => (
	<DpBottomContainer
		sx={combineSX([{ background: '#FBFBFC' }, ...(Array.isArray(sx) ? sx : [sx])])}
	>
		<Grid
			container
			columnSpacing={'80px'}
			sx={combineSX([...(Array.isArray(sxgrid) ? sxgrid : [sxgrid])])}
			{...props}
		>
			{children}
		</Grid>
	</DpBottomContainer>
);
